export const lineup = [{
        id: 0,
        day: 1,
        end: "13:00",
        time: "12:30",
        title: "Festival Warm-Up Party #1: Tune in LIVE!",
        type: 0,
        guests: [43]
    },
    {
        id: 2,
        day: 1,
        end: "13:11",
        time: "13:00",
        title: "Welcome to the iGEM Opening Weekend Festival!",
        type: 1,
        guests: [42, 22, 11, 64],
        embedId: "37d9864d-793d-4075-a6b8-6248e096c288",
        thumbnailId: "050250d0-d62b-4f19-999f-382b3448de25",
        duration: 585
    },
    {
        id: 3,
        day: 1,
        end: "13:18",
        time: "13:11",
        title: "iGEM: Local People Solving Local Problems",
        type: 1,
        guests: [37],
        embedId: "0aa460c4-0af4-4bae-8cc7-52062ba17f59",
        thumbnailId: "56c641c7-2687-49f1-887a-fe8b36700b3b",
        duration: 421
    },
    {
        id: 4,
        day: 1,
        end: "13:22",
        time: "13:18",
        title: "Meet the 2021 iGEM Teams",
        type: 3,
        guests: [],
        embedId: "dfa6cd3f-a0b5-46d0-bbd0-bab9862ff024",
        thumbnailId: "79b2e86f-ddaa-480b-8095-0b53d34cc4da",
        duration: 87
    },
    {
        id: 5,
        day: 1,
        end: "13:30",
        time: "13:22",
        title: "Your Regional Champions: iGEM Ambassadors",
        type: 3,
        guests: [16],
        embedId: "b3592758-0a60-422e-b6c5-9a449424d75c",
        thumbnailId: "1538d995-26b4-4f1f-968f-093950a5964a",
        duration: 382
    },
    {
        id: 7,
        day: 1,
        end: "13:47",
        time: "13:30",
        title: "The iGEM Rollercoaster: It's not easy but it's worth it!",
        type: 2,
        guests: [2, 21, 35],
        embedId: "ba92fcb3-4bb5-49d7-9d2e-1423d836bebb",
        thumbnailId: "1d0ac8f7-2bd7-40f1-8685-89503a2ccee5",
        duration: 977
    },
    {
        id: 8,
        day: 1,
        end: "14:10",
        time: "13:47",
        title: "Doing iGEM in the Time of Pandemic: How 2020 changed everything?",
        type: 2,
        guests: [56, 5, 1],
        embedId: "6b856f99-cc0e-4077-9c67-6dfa8a02eadd",
        thumbnailId: "d14c7fae-4acb-4515-8a70-51277e43981f",
        duration: 1256
    },
    {
        id: 9,
        day: 1,
        end: "14:22",
        time: "14:10",
        title: "Tackling Global Challenges: COVID19 iGEM Projects",
        type: 4,
        guests: [62, 32, 20, 54],
        embedId: "97cc14d2-9da9-42e3-b353-42088de2a7f2",
        thumbnailId: "533fa4a8-b22a-437d-8ae8-6b873a92e1e2",
        duration: 708
    },
    {
        id: 10,
        day: 1,
        end: "14:37",
        time: "14:22",
        title: "Safety & Security: SynBio Beyond Containment",
        type: 4,
        guests: [55],
        embedId: "38bd741e-5818-4d65-b022-489a231d50ec",
        thumbnailId: "ef6ca502-5d67-4f6d-a9c2-09c4cc2e9c6a",
        duration: 832
    },
    {
        id: 11,
        day: 1,
        end: "14:48",
        time: "14:37",
        title: "Engineering Biology: Design > Build > Test > Learn",
        type: 4,
        guests: [57, 49, 3],
        embedId: "6b2cf586-e1bb-405c-becd-c37f20797c6c",
        thumbnailId: "e40d5138-c59f-4592-9fe9-07020f8c14c2",
        duration: 621
    },
    {
        id: 12,
        day: 1,
        end: "15:01",
        time: "14:48",
        title: "Design League: A New iGEM Launching in Latin America",
        type: 3,
        guests: [50, 34],
        embedId: "7ac802fb-6c98-4a57-a733-196c63e35765",
        thumbnailId: "dc3c4c62-3ff1-4559-b582-db64b05f5fa8",
        duration: 719
    },
    {
        id: 13,
        day: 1,
        end: "15:19",
        time: "15:01",
        title: "The Future of the Lab: Automation & DNA Synthesis",
        type: 4,
        guests: [17, 70],
        embedId: "5989391a-1608-43cb-adf8-ae15c0aef511",
        thumbnailId: "13a3103e-b805-4a45-94e7-8a958ba8e5de",
        duration: 983
    },
    {
        id: 14,
        day: 1,
        end: "15:31",
        time: "15:19",
        title: "Pre-incubator: iGEM Startups & EPIC",
        type: 4,
        guests: [36, 12, 58],
        embedId: "fc769aa9-1693-421b-94bc-bcbe896c9a41",
        thumbnailId: "44c00c04-177e-44fe-b0b1-b6e77e5a3dde",
        duration: 658
    },
    {
        id: 15,
        day: 1,
        end: "15:46",
        time: "15:31",
        title: "An iGEM Failure Story: A Team's Cascade Of Mistakes",
        type: 2,
        guests: [63],
        embedId: "26d3baf1-6310-4d67-a0c7-931e60081ced",
        thumbnailId: "bd28e663-492d-424d-a0a5-1f270c0343b6",
        duration: 750
    },
    {
        id: 16,
        day: 1,
        end: "16:09",
        time: "15:46",
        title: "pov: an iGEM Finalist - William & Mary 2015 (UG Grand Prize Winner)",
        type: 2,
        guests: [29, 8],
        embedId: "d21b6e5d-e605-4f5c-8bc1-926fa21928df",
        thumbnailId: "97026ad2-e023-4ba6-9436-c62d01e3c365",
        duration: 1268
    },
    {
        id: 17,
        day: 1,
        end: "16:33",
        time: "16:09",
        title: "iGEM Values: A team's story from Sumbawa (2014 Chairman's Award)",
        type: 2,
        guests: [71, 72, 73, 74, 75, 76, 77],
        embedId: "9ef9d37c-c626-433c-96da-2fa0b3903ae4",
        thumbnailId: "5ea915d8-04f9-4957-8da1-466ad5b2a8af",
        duration: 1466
    },
    {
        id: 18,
        day: 1,
        end: "16:37",
        time: "16:33",
        title: "Day #1 Wrap Up",
        type: 1,
        guests: [22, 11, 64],
    },
    {
        id: 19,
        day: 2,
        end: "13:00",
        time: "12:30",
        title: "Festival Warm-Up Party #2: Tune in LIVE!",
        type: 0,
        guests: [43],
    },
    {
        id: 20,
        day: 2,
        end: "13:03",
        time: "13:00",
        title: "Welcome to OWF Day #2",
        type: 1,
        guests: [22, 11, 64],
    },
    {
        id: 21,
        day: 2,
        end: "13:19",
        time: "13:03",
        title: "iGEM as a Testbed for Global Technology Development",
        type: 4,
        guests: [38],
        thumbnailId: "b0ce3e20-e3f1-4b7d-94c6-276e6c498025",
        embedId: "912fdcf2-bea7-4f9f-b952-d041b43b7b24",
        duration: 884
    },
    {
        id: 22,
        day: 2,
        end: "13:38",
        time: "13:19",
        title: "Being Trustworthy & Human Practices",
        type: 3,
        guests: [25, 33],
        thumbnailId: "479548a0-fd75-4103-970a-e3bd2775fffc",
        embedId: "5a62dc45-c89f-46db-936b-0489e70f24c1",
        duration: 1032
    },
    {
        id: 23,
        day: 2,
        end: "13:52",
        time: "13:38",
        title: "The Intro to Your Project: Promotion Video",
        type: 2,
        guests: [30, 11, 42],
        thumbnailId: "ae911b95-2b6c-48ba-9655-160c8ed99995",
        embedId: "ba348ba1-47a4-4d5f-821a-1372b7fc8813",
        duration: 880
    },
    {
        id: 24,
        day: 2,
        end: "13:54",
        time: "13:52",
        title: "Promo: iGEM Phoenix Project",
        type: 2,
        guests: [78],
        thumbnailId: "2c2f2ed9-35bb-4854-b9ec-d524bf1fc91d",
        embedId: "a1ced8d5-ff0d-4f77-adaa-2a0ff3885f41",
        duration: 101
    },
    {
        id: 25,
        day: 2,
        end: "14:11",
        time: "13:54",
        title: "pov: an iGEM Finalist - Vilnius-Lithuania 2020 (UG Grand Prize Winner)",
        type: 2,
        guests: [26, 19],
        thumbnailId: "7acf8471-c752-4f34-b57f-23deb543ddcc",
        embedId: "26d091be-7d70-4f2a-885f-903851e4c20e",
        duration: 914
    },
    {
        id: 26,
        day: 2,
        end: "14:29",
        time: "14:11",
        title: "Navigating the 2021 Competition: Requirements, Resources & Medals",
        type: 3,
        guests: [56],
        thumbnailId: "442004d8-319f-4042-b9cf-5805be839ec6",
        embedId: "be586af5-d90f-46f9-9eed-aaf1cfad47d6",
        duration: 865
    },
    {
        id: 27,
        day: 2,
        end: "14:43",
        time: "14:29",
        title: "High School iGEM",
        type: 2,
        guests: [39, 40],
        thumbnailId: "415151b0-61a4-4da4-a899-e039edf6ff67",
        embedId: "0255d7e4-20f9-4aa6-8004-24cab94fd24b",
        duration: 785
    },
    {
        id: 28,
        day: 2,
        end: "14:58",
        time: "14:43",
        title: "The Final Countdown: Wiki Freeze",
        type: 2,
        guests: [28, 31, 45],
        thumbnailId: "484a671b-4b24-4db1-9e53-f588f982957c",
        embedId: "9b35b9e2-16ed-4b6a-a166-06ac52afed4d",
        duration: 789
    },
    {
        id: 29,
        day: 2,
        end: "15:17",
        time: "14:58",
        title: "pov: an iGEM Judge",
        type: 3,
        guests: [23, 47, 44],
        thumbnailId: "89b94739-c4be-480b-a7a9-98315e06b14e",
        embedId: "f1256bc5-279d-4b52-bf94-f9cffe0f33b4",
        duration: 1061
    },
    {
        id: 30,
        day: 2,
        end: "15:21",
        time: "15:17",
        title: "Promo: iGEM TV Launching Soon!",
        type: 2,
        guests: [22],
        thumbnailId: "c57e1605-ddd2-43e2-8dcd-9dfbec5b33f8",
        embedId: "d9b757ae-aeac-4816-b4e9-e50351dfc9e9",
        duration: 82
    },
    {
        id: 31,
        day: 2,
        end: "15:25",
        time: "15:21",
        title: "Global Community of iGEM Mentors",
        type: 3,
        guests: [41, 13],
        thumbnailId: "0a23a271-72c4-4919-9ef7-7c1bd0c24a3c",
        embedId: "e02851ca-2290-42ec-936d-24854232a1b8",
        duration: 235
    },
    {
        id: 32,
        day: 2,
        end: "15:46",
        time: "15:25",
        title: "Team Meetups & Collaborations",
        type: 3,
        guests: [6, 15, 59, 27, 67, 68, 66, 65],
        thumbnailId: "7962a84f-9ce8-4487-8755-74be5eabe221",
        embedId: "e5d63adc-8732-4f99-a7d7-52c248a09357",
        duration: 1207
    },
    {
        id: 33,
        day: 2,
        end: "16:08",
        time: "15:46",
        title: "The Future of Distribution & Sharing",
        type: 4,
        guests: [18, 60],
        thumbnailId: "7569017e-4e42-42ee-8f0b-1aa7598068f4",
        embedId: "5c29ccc2-163d-4b35-b855-193901a0027e",
        duration: 1306
    },
    {
        id: 34,
        day: 2,
        end: "15:11",
        time: "15:08",
        title: "Special Grant Announcement",
        type: 1,
        guests: [69],
        thumbnailId: "bfa35560-fec6-40f1-b1ca-4682cca8088c",
        embedId: "17113c6a-f433-4842-bfd6-9f90823c38f4",
        duration: 150
    },
    {
        id: 35,
        day: 2,
        end: "16:15",
        time: "16:11",
        title: "The 2021 iGEM Jamboree Parties",
        type: 1,
        guests: [42, 16],
        thumbnailId: "74204aa0-a155-4e89-bc0c-c5a14333cd90",
        embedId: "b0163bf8-2a25-4f84-8e4b-79819399d945",
        duration: 167
    },
    {
        id: 36,
        day: 2,
        end: "16:18",
        time: "16:15",
        title: "Day #2 Wrap Up",
        type: 1,
        guests: [22, 11, 64],
        duration: 244,
        embedId: "66dd6880-2015-4423-a0ca-aefadc40e7f6",
        thumbnailId: "020db94f-cc32-4c01-9c9c-50542a1b5285"
    },
];

export const additionalVideos = [{
        id: 1,
        title: "iGEM 2021 Trailer",
        type: 1,
        duration: 135,
        embedId: '8d3e5a31-de22-4686-a91f-5f54f43ffa9a',
        thumbnailId: '909b0a4c-e1fe-419c-ae1d-2041444352da'
    },
    {
        id: 6,
        title: "Message from 2021 iGEM Ambassadors",
        type: 1,
        duration: 220,
        embedId: '243aec90-d1e2-4c02-b2bf-0ef667fc229f',
        thumbnailId: '0eec7b2a-23cd-4d37-aa91-7d1c07b10779'
    }
]

export const zoomSessions = [{
        id: 0,
        type: 3,
        title: "Meet your iGEM Ambassador",
        embedId: "29d0f010-2e95-438c-a512-a7c61c9f6ce6",
        thumbnailId: "3a567256-e5b3-44be-adbe-bee72136bc36",
        duration: 2334
    },
    {
        id: 1,
        type: 2,
        title: "Discussing the iGEM Rollercoaster with Alumni",
        embedId: "39be5c26-7b4b-403e-88cd-714839d8ba74",
        thumbnailId: "87ded6ab-bc02-46bf-8d82-74d4672c49d9",
        duration: 1984
    },
    {
        id: 2,
        type: 2,
        title: "Are we still doing iGEM in the time of pandemic?",
        embedId: "2ff361b4-69f9-4ef2-a43b-9cdf98e50972",
        thumbnailId: "e9333b45-17ec-48a5-9710-44f81b6b8e39",
        duration: 2201
    },
    {
        id: 3,
        type: 4,
        title: "Reflections from Leiden and TAS_Taipei 2020",
        embedId: "ca70b3cc-e263-4907-b5de-6e51feeac8da",
        thumbnailId: "16026a1b-7910-4f88-81ec-34594aa9dcf1",
        duration: 1097
    },
    {
        id: 4,
        type: 4,
        title: "iGEM Safety & Security Program",
        embedId: "1168e3ad-d49a-4df7-b9aa-3a46f82bceb8",
        thumbnailId: "420b1460-32cb-499f-a990-b66283b291a3",
        duration: 2117
    },
    {
        id: 5,
        type: 4,
        title: "The Engineering Cycle: How can the committee help you?",
        embedId: "1821361d-638c-43da-b143-04259230e777",
        thumbnailId: "f67876e0-feb2-49eb-bc80-65651b0b2046",
        duration: 2730
    },
    {
        id: 6,
        type: 3,
        title: "iGEM Design League: Latin America",
        embedId: "2ed5a90d-fc6b-472d-b8eb-fadcf2d8502a",
        thumbnailId: "6e507e83-fd0a-486c-9d41-7ecd2d6dfa6b",
        duration: 1793
    },
    {
        id: 7,
        type: 4,
        title: "The Future of the Lab: Automation & DNA Synthesis",
        embedId: "f5263100-f089-421f-abf2-dbd7c7c9b234",
        thumbnailId: "af5b062f-a5b7-4830-97a8-39bdd8233aaf",
        duration: 2612
    },
    {
        id: 8,
        type: 4,
        title: "Entrepreneurial Journey in iGEM",
        embedId: "0a23301b-7e71-48a9-9ddc-ca0bdc1d8f04",
        thumbnailId: "c27b5f66-2ab3-4b37-9c26-be1a79b2444c",
        duration: 1990
    },
    {
        id: 9,
        type: 2,
        title: "An iGEM Failure Story",
        embedId: "2cbe509d-8a2f-4525-b1b7-f9c4222cac56",
        thumbnailId: "c66f241d-36aa-4c12-9b80-2f740d95fffd",
        duration: 1917
    },
    {
        id: 10,
        type: 2,
        title: "2015 Grand Prize Winner: William & Mary",
        embedId: "3ca809c4-5145-40f4-904c-187538cb5b23",
        thumbnailId: "87282ca6-8421-4772-9309-cd5228a1c312",
        duration: 1910
    },
    {
        id: 11,
        type: 3,
        title: "Discussing HP & Trustworthiness",
        embedId: "ec3b0f62-7d4f-492f-b731-85d1a517a89e",
        thumbnailId: "93df121d-a3c5-493e-aa63-021720922b19",
        duration: 2263
    },
    {
        id: 12,
        type: 2,
        title: "2020 Grand Prize Winner: Vilnius-Lithuania",
        embedId: "9b08c210-3006-4534-8483-9b0885beb1e9",
        thumbnailId: "547cdd55-d4c3-43fa-ab71-9de64e9a0871",
        duration: 1935
    },
    {
        id: 13,
        type: 3,
        title: "Navigating the Competition",
        embedId: "f1080672-ab4e-4b2f-a890-572897680121",
        thumbnailId: "f27a6c9b-ab94-4a9e-a48d-7ba41b587af7",
        duration: 3289
    },
    {
        id: 14,
        type: 2,
        title: "High School iGEM",
        embedId: "d31dac7f-9ca4-48c8-9ae6-9a765018acb0",
        thumbnailId: "9b02ef42-bd4d-4993-b400-1e56162278c1",
        duration: 1952
    },
    {
        id: 15,
        type: 2,
        title: "Wiki Freeze Stories & Advice",
        embedId: "88770066-3152-40ce-a388-3faf38754939",
        thumbnailId: "07784290-bdb2-44b5-8201-9c382ad72a83",
        duration: 2194
    },
    {
        id: 16,
        type: 3,
        title: "Become an iGEM Judge",
        embedId: "970bf969-7a18-4d78-85f0-9d1c0e065d86",
        thumbnailId: "c6f648ce-bfef-49cd-ba9b-fec0c8054a1f",
        duration: 2584
    },
    {
        id: 17,
        type: 3,
        title: "The Mentorship Program",
        embedId: "30a101bf-2c63-4070-83bd-433c5a9faada",
        thumbnailId: "27f8790e-85fd-40e4-80a2-2cef41ac95e9",
        duration: 2144
    },
    {
        id: 18,
        type: 3,
        title: "Meetup & Collaboration Stories",
        embedId: "cf8c29fd-b171-412e-b373-1503d1d1ab80",
        thumbnailId: "0256df29-8b96-4283-aab3-4f313d677c46",
        duration: 2285
    },
    {
        id: 19,
        type: 4,
        title: "Distribution Discussions",
        embedId: "51fba931-edc4-4849-8c94-1b35ca290522",
        thumbnailId: "a0e9f208-d19d-4e41-a160-ffee595773c3",
        duration: 3744
    }
]